import {DataTableCellProps, TemporalFormat, tryParseInstant} from "@variocube/app-ui";
import React from "react";
import {Booking} from "../../api";

export function BookingUntilCell({row}: DataTableCellProps<Booking>) {
	const until = tryParseInstant(row.until);
	return until ? <TemporalFormat value={until} /> : null;
}
